
import {
  defineComponent
} from 'vue'

import { useRoute } from 'vue-router'
import usePageUtil from '@/pages/composables/usePageUtil'
import Page from '@/layouts/Page.vue'

export default defineComponent({
  name: 'ManageInventoryIndex',
  components: { Page },
  setup () {
    const $route = useRoute()

    const {
      activeView,
      currentParent,
      currentRoute
    } = usePageUtil($route, __dirname)

    return {
      activeView,
      currentParent
    }
  }
})
